// Initial State
export const model = {
  country: null,
  searchedLocation: null,
};

const locationReducer = (state = model) => state;

export default locationReducer;
